import { useDispatch, useSelector } from 'react-redux'
import { useMemo } from 'react'
import styles from './ChatPageV2.module.scss'
import { Avatar } from '@mui/material'
import { setCurrentSelectedGroup } from '../../features/groupSlice'
import { getTimePassed } from '../../util/getTime'

export const GroupChatList = ({ closeSidebar, toggleSidebar, searchQuery }) => {
  const dispatch = useDispatch()

  const currentSelectedGroup = useSelector((s) => s.group.currentSelectedGroup)
  const groupList = useSelector((s) => s.group.groups)

  const filtered = useMemo(() => {
    const q = (searchQuery || '').toLowerCase().trim()
    const byTimeDesc = (a, b) => {
      const ta = a?.latestMessage?.createdAt ? new Date(a.latestMessage.createdAt).getTime() : 0
      const tb = b?.latestMessage?.createdAt ? new Date(b.latestMessage.createdAt).getTime() : 0
      return tb - ta
    }
    return (groupList || [])
      .filter((g) => (g?.name || '').toLowerCase().includes(q))
      .slice()
      .sort(byTimeDesc)
  }, [groupList, searchQuery])

  const handleChatSelect = (group) => {
    dispatch(setCurrentSelectedGroup(group))
    if (window.innerWidth <= 768) closeSidebar?.()
  }

  return (
    <ul className={styles.chatList}>
      {filtered.map((group) => (
        <li
          key={group._id}
          className={`${styles.chatItem} ${currentSelectedGroup?._id === group._id ? styles.selected : ''}`}
          onClick={() => handleChatSelect(group) || toggleSidebar()}
        >
          <div className={`${styles.avatar} ${styles.group}`}>
            <Avatar
              src={group.groupProfilePic}
              alt="avatar"
              className={styles.avatar__img}
            />
          </div>

          <div className={styles.chatInfo}>
            <h4 className={styles.userName}>{group.name}</h4>
            {group.latestMessage?.fileUrl && !group.latestMessage?.text ? (
              <p className={styles.lastMessage}>
                <span style={{ marginRight: '4px' }}>📄</span>
                Attachment
              </p>
            ) : (
              !!group.latestMessage?.text && (
                <p className={styles.lastMessage}>{group.latestMessage.text}</p>
              )
            )}
          </div>

          <div className={styles.chatMeta}>
            {!!group.latestMessage?.createdAt && (
              <span className={styles.timeStamp}>
                {getTimePassed(group.latestMessage.createdAt)}
              </span>
            )}
            {group.unreadCount > 0 && (
              <span className={styles.unreadBadge}>
                {group.unreadCount > 99 ? '99+' : group.unreadCount}
              </span>
            )}
          </div>
        </li>
      ))}
    </ul>
  )
}
